import { Component, Inject, NgModule, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UserSubscription } from 'src/app/models/user-subscription.model';
import { PaymentService } from 'src/app/services/payment.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { MatProgressBar, MatProgressBarModule } from "@angular/material/progress-bar";
import { CommonModule, DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

interface Data {
	sub: UserSubscription;
}

@Component({
	selector: 'app-cancel-dialog',
	templateUrl: './cancel-dialog.component.html',
	styleUrls: ['./cancel-dialog.component.scss'],
 imports: [MatProgressBar, DatePipe, MatDialogModule, MatProgressBarModule, MatButtonModule, CommonModule]
})
export class CancelDialogComponent implements OnInit {

	loading: boolean = false;
	sub!: any;
	userId: string = '';

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: Data,
		private customerPaymentService: PaymentService,
		private tokenService: TokenStorageService,
		public dialogRef: MatDialogRef<CancelDialogComponent>
	) { }

	ngOnInit() {
		this.sub = this.data;
		this.userId = this.tokenService.getUser().id
	}

	confirmCancel(): void {
		this.loading = true;
		this.customerPaymentService.put(['CancelSubscription', this.sub.userSubscriptionId ], this.userId ).subscribe(() => {
			this.loading = false;
			this.sub.subscriptionCancelAtPeriodEnd = true;
			this.dialogRef.close();
		});
	}
}